import { PORTAL_TABS } from "@portal/Components/Portal/PotalTabs/types";

export const appPageName = [
  "LOGIN",
  "FORGOT_PASSWORD",
  "PORTAL",
  "INVOICE_DETAILS",
  "DISPUTE_DETAILS",
  "PTP_DETAILS",
  "CREDIT_DETAILS",
  "PAYMENT_DETAILS",
] as const;

const appPageParams = [
  "customer_id",
  "invoice_id",
  "dispute_id",
  "credits_id",
  "payment_id",
  "ptp_id",
  "payment_id",
] as const;

export type AppPageParams = Partial<
  Record<(typeof appPageParams)[number], string>
>;

export type AppPageName = Readonly<typeof appPageName> | PORTAL_TABS;

export type RouteConfig = {
  path: Path;
  routePath: RoutePath;
};
export type RoutePathConfig = Record<AppPageName[number], RouteConfig>;
type RoutePath = string;
type Path = string;
interface PageDetails {
  path: Path;
  routePath: RoutePath;
  title: string;
  backLinks: AppPageName[number][];
}
type AppPage = Readonly<Record<AppPageName[number], PageDetails>>;

export const routePathConfig: RoutePathConfig = {
  LOGIN: {
    path: "/login",
    routePath: "login",
  },
  FORGOT_PASSWORD: {
    path: "/forget-password",
    routePath: "forget-password",
  },
  PORTAL: {
    path: "customers/:customer_id",
    routePath: "customers/:customer_id",
  },
  INVOICES: {
    path: "customers/:customer_id/invoices",
    routePath: "invoices",
  },
  PAYMENTS: {
    path: "customers/:customer_id/payments",
    routePath: "payments",
  },
  CREDIT_NOTES: {
    path: "customers/:customer_id/credit-notes",
    routePath: "credit-notes",
  },
  DISPUTES: {
    path: "customers/:customer_id/disputes",
    routePath: "disputes",
  },
  PTPs: {
    path: "customers/:customer_id/ptps",
    routePath: "ptps",
  },
  DOCUMENTS: {
    path: "customers/:customer_id/documents",
    routePath: "documents",
  },
  PROFILE: {
    path: "customers/:customer_id/profile",
    routePath: "profile",
  },
  INVOICE_DETAILS: {
    path: "customers/:customer_id/invoices/:invoice_id",
    routePath: ":invoice_id",
  },
  DISPUTE_DETAILS: {
    path: "customers/:customer_id/disputes/:dispute_id",
    routePath: ":dispute_id",
  },
  PTP_DETAILS: {
    path: "customers/:customer_id/ptps/:ptp_id",
    routePath: ":ptp_id",
  },
  CREDIT_DETAILS: {
    path: "customers/:customer_id/credit-notes/:credits_id",
    routePath: ":credits_id",
  },
  PAYMENT_DETAILS: {
    path: "customers/:customer_id/payments/:payment_id",
    routePath: ":payment_id",
  },
};
export const appPage: AppPage = {
  LOGIN: {
    path: routePathConfig.LOGIN.path,
    routePath: routePathConfig.LOGIN.routePath,
    title: "login",
    backLinks: [],
  },
  FORGOT_PASSWORD: {
    path: routePathConfig.FORGOT_PASSWORD.path,
    routePath: routePathConfig.FORGOT_PASSWORD.path,
    title: "login",
    backLinks: [],
  },
  PORTAL: {
    path: routePathConfig.PORTAL.path,
    routePath: routePathConfig.PORTAL.routePath,
    title: "login",
    backLinks: [],
  },
  INVOICES: {
    path: routePathConfig.INVOICES.path,
    routePath: routePathConfig.INVOICES.routePath,
    title: "login",
    backLinks: [],
  },
  PAYMENTS: {
    path: routePathConfig.PAYMENTS.path,
    routePath: routePathConfig.PAYMENTS.routePath,
    title: "login",
    backLinks: [],
  },
  CREDIT_NOTES: {
    path: routePathConfig.CREDIT_NOTES.path,
    routePath: routePathConfig.CREDIT_NOTES.routePath,
    title: "login",
    backLinks: [],
  },
  DISPUTES: {
    path: routePathConfig.DISPUTES.path,
    routePath: routePathConfig.DISPUTES.routePath,
    title: "login",
    backLinks: [],
  },
  PTPs: {
    path: routePathConfig.PTPs.path,
    routePath: routePathConfig.PTPs.routePath,
    title: "login",
    backLinks: [],
  },
  DOCUMENTS: {
    path: routePathConfig.DOCUMENTS.path,
    routePath: routePathConfig.DOCUMENTS.routePath,
    title: "login",
    backLinks: [],
  },
  PROFILE: {
    path: routePathConfig.PROFILE.path,
    routePath: routePathConfig.PROFILE.routePath,
    title: "login",
    backLinks: [],
  },
  INVOICE_DETAILS: {
    path: routePathConfig.INVOICE_DETAILS.path,
    routePath: routePathConfig.INVOICE_DETAILS.routePath,
    title: "login",
    backLinks: [],
  },
  DISPUTE_DETAILS: {
    path: routePathConfig.DISPUTE_DETAILS.path,
    routePath: routePathConfig.DISPUTE_DETAILS.routePath,
    title: "login",
    backLinks: [],
  },
  PTP_DETAILS: {
    path: routePathConfig.PTP_DETAILS.path,
    routePath: routePathConfig.PTP_DETAILS.routePath,
    title: "login",
    backLinks: [],
  },
  CREDIT_DETAILS: {
    path: routePathConfig.CREDIT_DETAILS.path,
    routePath: routePathConfig.CREDIT_DETAILS.routePath,
    title: "login",
    backLinks: [],
  },
  PAYMENT_DETAILS: {
    path: routePathConfig.PAYMENT_DETAILS.path,
    routePath: routePathConfig.PAYMENT_DETAILS.routePath,
    title: "login",
    backLinks: [],
  },
};
